import { transDataToValue as transUploadToValue, transValueToData as transUploadToData } from '@/components/Uploader'
import { OPERATION } from '@/components/OperationWidgets/OperationConst'

export const transDataToValue = values => {
    const { headPicture, qrCode, disabled, ...rest } = values || {}

    return {
        ...(rest || {}),
        disabled: !disabled,
        headPicture: transUploadToValue(headPicture),
        qrCode: transUploadToValue(qrCode)
    }
}

export const transValueToData = values => {
    const { disabled, headPicture, qrCode, ...rest } = values || {}
    return {
        ...rest,
        disabled: !disabled,
        headPicture: transUploadToData(headPicture),
        qrCode: transUploadToData(qrCode),
        remark: OPERATION
    }
}
